import React from 'react';
import ReactDOM from 'react-dom/client'
import Main from "./components/Main.js"
import Navbar from "./components/Navbar.js"
import Name from "./components/Name"

import './index.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <div> 
        <Main 
        className="Main"/>
    </div>

);
